<app-list-log [tipo]="'completo'"></app-list-log>

